import React, { FC } from 'react'
import { Button, Input, Select, Form } from 'antd';
import { RefreshIcon, ResetIcon  } from "../../../../../../assets/images/icon/svg";
import {DepartmentHeadRecommendationAction} from "../Actions/DepartmentHeadRecommendation.actions";
import BulkAction from "../../../../../../components/Actions/BulkAction";
import { useTranslation } from "react-i18next";

const DepartmentHeadRecommendationListFilter: FC<any> = props => {
    const { t } = useTranslation();
    const { Search } = Input;
    const { Option } = Select;
    const { filters, handleOnChanged, handleCallbackFunc } = props;
    return (
        <div className="listing-page-filter">
            <div className="filter-section filter-top">
                <div className="page-heading-title">
                    <h1 className="m-0 fs-3 fw-bold page-title-dashboard">{t('প্রতিষ্ঠান প্রধান / বিভাগীয় প্রধানের সুপারিশ')}</h1>
                </div>
            </div>
            <div className="filter-section filter-bottom">
                <div className="filter-bottom-left">
                    <div className="filter-box-left input-box search-box">
                        <Form.Item name="search">
                            <Search placeholder={t("Search")} onSearch={(value) => handleOnChanged('search', value, '')} />
                        </Form.Item>
                    </div>
                    <div className="filter-box-left select-box status-box">
                        <Form.Item name="status">
                            <Button>{t('Status')}:</Button>
                            <Select
                                showSearch
                                dropdownMatchSelectWidth={100}
                                defaultValue={filters.status}
                                optionFilterProp="children"
                                onChange={(value) => handleOnChanged('filter_status', value)}
                                filterOption={(input, option: any) => option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            >
                                <Option value="">{t('All')}</Option>
                                <Option value="0">{t('Pending')}</Option>
                                <Option value="1">{t('Accepted')}</Option>
                                <Option value="2">{t('Rejected')}</Option>
                            </Select>
                        </Form.Item>
                    </div>
                    <div className="filter-box-left button-box reset-button-box">
                        <Button type="link" icon={<ResetIcon />} onClick={(event) => handleCallbackFunc(null, 'resetListing')}>{t('Reset')}</Button>
                    </div>
                </div>

                <div className="filter-bottom-right">
                    <div className="filter-box-right button-box reload-button-box">
                        <Button type="link" onClick={(event) => handleCallbackFunc(null, 'reloadListing')}><RefreshIcon /></Button>
                    </div>
                    <BulkAction bulkAction={DepartmentHeadRecommendationAction.BULK_ACTION} handleCallbackFunc={handleCallbackFunc} />
                </div>
            </div>
        </div>
    );
}
export default React.memo(DepartmentHeadRecommendationListFilter);
